<app-configuracao-caixa [acoesConta]="acoesConta" [contas]="contas" (reloadPage)="reloadPage()" [mostrarAdicionarTipo]="true" [mostrarSelecaoEmMassa]="true">

  <a routerLink="/contas-arquivadas" mat-raised-button class="button-menu" matTooltip="Contas Arquivadas">
    <i class="button-menu-icon pi pi-eye"></i>
    <span class="button-menu-label">Contas Arquivadas</span>
  </a>

  <button mat-raised-button [matMenuTriggerFor]="adicionarContaMenu" class="button-menu" matTooltip="Criar Conta">
    <i class="button-menu-icon pi pi-plus"></i>
    <span class="button-menu-label">Criar Conta</span>
  </button>
  <mat-menu #adicionarContaMenu="matMenu" xPosition="before">
    <button mat-menu-item class="inline-element accent-color" (click)="abrirAdicionarContaDialog()">
      Criar Manualmente
    </button>
    <button *hasPermission="permissaoEditarLancamento" mat-menu-item class="inline-element accent-color" (click)="importContasCaixa.click()">
      Importar lançamentos
    </button>
    <input #importContasCaixa type="file" class="display-none" [accept]="excelFileType"
      (change)="importarLancamentosCaixa(importContasCaixa)">
  </mat-menu>

</app-configuracao-caixa>